import { useMemo } from 'react';
import { useDateRangeTexts } from '../useDateRangeTexts';
import { localize } from './builtInPresets';

export function useBuiltInPresets() {
  const texts = useDateRangeTexts().presets;

  return useMemo(() => localize(texts), [texts]);
}
